import { gql, useSubscription } from '@apollo/client'

export const PRESCRIPTIONS_WIDGET_SUBSCRIPTION = gql`
  subscription PrescriptionsWidget(
    $patientId: ID!
    $offset: PageOffset = 0
    $limit: Int = 5
  ) {
    prescriptionWidget(patientId: $patientId, offset: $offset, limit: $limit) {
      prescriptions {
        ... on Prescription {
          id
          businessId
          business {
            id
            name
          }
          client {
            id
          }
          patient {
            id
            name
          }
          doctor {
            id
            firstName
            lastName
          }
          soapId
          categoryId
          name
          rxNo
          type
          administrationQuantity
          administrationQuantityUnit {
            id
            name
          }
          administrationQuantityCustomUnit
          administrationFrequency {
            id
            name
          }
          administrationFrequencyNotes
          administrationCourseType
          administrationCourseLength
          administrationRoute {
            id
            name
          }
          drugExpirationDate
          prescribedDate
          globalInventoryId
          globalVariationId
          globalFoodCatalogId
          globalFoodCatalogVariationId
          globalInventoryMapping {
            id
            name
            category {
              id
              name
            }
            subCategory {
              id
              name
            }
            creationDate
            modificationDate
            modifier {
              id
              firstName
              lastName
            }
            type
          }
          globalVariationMapping {
            id
            name
            strength
            flavor
            form {
              id
              name
            }
            deliveryMethod {
              id
              name
            }
            strengthUnit {
              id
              name
            }
            strengthColor {
              id
              name
            }
            chewyItems {
              name
              partNumber
              price
              inStock
              strength
              count
            }
            globalInventoryMapping {
              id
              name
            }
            strengthCombo
            weightMinimum
            weightMaximum
            obsolete
            partNumber
          }
          inventoryId
          numberRefills
          quantityPerRefill
          quantityPerRefillUnit {
            id
            name
          }
          quantityPerRefillCustomUnit
          refillExpirationDate
          totalQuantity
          totalQuantityUnit {
            id
            name
          }
          totalQuantityCustomUnit
          deleted
          createdAt
          updatedAt
          rejectionReason
          state {
            id
            name
          }
          compoundingReasonState {
            id
            name
          }
          compoundingReason
          notes
          orderNumber
          drugInfo {
            masterName
            variationName
            description
            form {
              id
              name
            }
            strength
            strengthUnits {
              id
              name
            }
          }
          mismatchWarning
          pdfUrl
          rxType
          signatureUrl
          signer {
            id
            firstName
            lastName
          }
          signedDate
          price {
            id
            businessId
            name
            price
            currency {
              id
              name
            }
            unit {
              id
              name
            }
          }
          partNumber
          origin
          timelineDate
          refillsLeft
          retailOrderLineItem {
            id
            name
          }
          invoice {
            id
            invoiceNo
            type
            posted
          }
          masterName
          controlled
          isOTC
          cancelledBy {
            id
          }
          catalogVariation {
            id
          }
        }
        ... on MedicalHistory {
          id
          externalPatientId
          date
          name
          medicalHistoryType: type
          details
          version
          medicalHistoryDeleted: deleted
          externalId
          creationDate
          modificationDate
          business {
            id
          }
          patient {
            id
          }
        }
      }
      prescriptionCounters {
        prescriptionCount
      }
    }
  }
`

export const usePrescriptionsWidgetSubscription = (
  patientId: string,
  offset: number,
  limit: number,
) =>
  useSubscription(PRESCRIPTIONS_WIDGET_SUBSCRIPTION, {
    variables: {
      patientId,
      offset,
      limit,
    },
    skip: !patientId,
  })
